/**
 * MS-09 wave2 (Cowork · 2026-06-07) · «Собери цикл» — порядок 6 фаз SDLC.
 *
 * Mechanic: пул кнопок-фаз в перемешанном порядке + цепочка-приёмник.
 * Клик по фазе в правильном порядке переносит её чипом в цепочку (6-я фаза —
 * чип .loop, акцент возврата Maintenance → Requirements); ошибка — shake;
 * 2 ошибки подряд — текстовая подсказка по смыслу фазы; финал — сообщение
 * про цикл. «Собрать заново» — программный reset (НЕ reload).
 *
 * Markup contract (per sprint-01.ts MS-09):
 *   <div class='phase-chain'>
 *     <div class='pc-hint'>…</div>
 *     <div class='pc-chain'><span class='pc-slot'>1 → … → 6</span></div>
 *     <div class='pc-pool'><button class='pc-btn' data-ord='N'>Phase</button> ×6</div>
 *     <div class='pc-msg' role='status' aria-live='polite'></div>
 *     <button class='pc-reset'>Собрать заново</button>
 *   </div>
 *
 * State session-only (как mythCards) — повторный заход = повторная сборка.
 */
export function initPhaseChains(root: HTMLElement): () => void {
  const blocks = Array.from(root.querySelectorAll<HTMLElement>('.phase-chain'));
  const cleanups: Array<() => void> = [];
  const HINTS = [
    '',
    'про «что мы делаем»',
    'про «как мы это сделаем»',
    'где пишут код',
    'где ищут баги',
    'где выкатывают к пользователям',
    'где продукт живёт дальше',
  ];

  for (const block of blocks) {
    if (block.dataset.pcInit === '1') continue;
    block.dataset.pcInit = '1';
    const chain = block.querySelector<HTMLElement>('.pc-chain');
    const pool = block.querySelector<HTMLElement>('.pc-pool');
    const msg = block.querySelector<HTMLElement>('.pc-msg');
    const reset = block.querySelector<HTMLButtonElement>('.pc-reset');
    if (!chain || !pool || !msg || !reset) continue;

    const slotHtml = chain.innerHTML;
    let next = 1;
    let wrong = 0;

    const show = (kind: string, html: string) => {
      msg.className = 'pc-msg ' + kind;
      msg.innerHTML = html;
    };

    const onPool = (e: MouseEvent) => {
      const btn = (e.target as HTMLElement).closest<HTMLButtonElement>('.pc-btn');
      if (!btn || btn.disabled) return;
      const ord = Number(btn.dataset.ord);
      if (ord === next) {
        if (next === 1) chain.innerHTML = '';
        const chip = document.createElement('span');
        chip.className = 'pc-done-chip' + (ord === 6 ? ' loop' : '');
        chip.innerHTML = "<span class='n'>" + ord + '</span>' + (btn.textContent ?? '');
        chain.appendChild(chip);
        btn.disabled = true;
        next += 1;
        wrong = 0;
        msg.className = 'pc-msg';
        if (next === 7) {
          show(
            'ok',
            '<strong>Цикл собран.</strong> И помни: из Maintenance стрелка ведёт обратно в Requirements — поэтому это круг, а не прямая.',
          );
          reset.style.display = 'inline-block';
        }
      } else {
        wrong += 1;
        btn.classList.add('shake');
        window.setTimeout(() => btn.classList.remove('shake'), 350);
        if (wrong >= 2) show('hint', 'Подсказка: фаза ' + next + ' — ' + HINTS[next] + '.');
      }
    };

    const onReset = () => {
      next = 1;
      wrong = 0;
      msg.className = 'pc-msg';
      reset.style.display = 'none';
      chain.innerHTML = slotHtml;
      pool.querySelectorAll<HTMLButtonElement>('.pc-btn').forEach((b) => {
        b.disabled = false;
      });
    };

    pool.addEventListener('click', onPool);
    reset.addEventListener('click', onReset);
    cleanups.push(() => {
      pool.removeEventListener('click', onPool);
      reset.removeEventListener('click', onReset);
      delete block.dataset.pcInit;
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
